module.exports = __webpack_public_path__ + "img/vertical_4_3_3016.019fe20b.png";